import { Injectable } from '@angular/core';
import { AbstractCatalogOptionLoader } from './catalog-option-loader.service';
import { CATALOG_CODE, CatalogCodeType } from '../../../../../shared/constants/catalog-codes';

@Injectable()
export class UnloadTimeOptionLoader extends AbstractCatalogOptionLoader {
  getCatalogType(): CatalogCodeType {
    return CATALOG_CODE.DISCHARGE_TIME;
  }
}
